@let controls = form().controls;
@let unitSelectClass = (isLeak() ? 'min-w-[5.5rem] ' : 'min-w-[7.5rem] ') + 'p-special !h-[2.75rem]';

<div class="flex flex-col gap-[1rem]" [formGroup]="form()">
  <div class="grid grid-cols-1 items-start gap-[1rem] sm:grid-cols-3 sm:gap-[0.75rem]">
    @if (isLeak()) {
      <div class="flex flex-col gap-[0.375rem]">
        <label class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)"
               for="dialog-event-leak-size">
          <span translate="@@fp-event-field__leak-size"></span>
        </label>

        <div class="flex items-stretch gap-[0.5rem]">
          <input id="dialog-event-leak-size"
                 pInputText
                 type="number"
                 min="0"
                 step="0.1"
                 inputmode="decimal"
                 autocomplete="off"
                 placeholder="0.0"
                 formControlName="leakSize"
                 class="flex-1 min-w-0 !h-[2.75rem] !text-[0.875rem] !font-medium placeholder:!text-(--p-gray-300)"
                 [class]="hasError(controls.leakSize) ? '!border-(--p-other-red-500)' : ''"/>

          <span class="flex shrink-0 items-center text-[0.875rem] font-medium text-(--p-gray-950)" [translate]="flowUnitLabels[controls.leakSizeUnit.value]"></span>
        </div>

        @if (hasError(controls.leakSize)) {
          <span class="text-[0.75rem] font-medium text-(--p-other-red-500)"
                translate="@@fp-event-validation__leak-size"></span>
        }
      </div>
    } @else {
      <div class="flex flex-col gap-[0.375rem]">
        <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)">
          <span translate="@@fp-event-field__non-leak-details"></span>
        </span>

        <p-select #nonLeakSelect
                  panelStyleClass="p-special"
                  formControlName="nonLeakNoiseSource"
                  styleClass="w-full p-special !h-[2.75rem]"
                  [overlayOptions]="overlayOptions"
                  [options]="nonLeakOptions"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'@@fp-event-field__non-leak-details-placeholder' | translate">
          <ng-template #dropdownicon>
            <svg-icon class="text-inherit"
                      [src]="nonLeakSelect.overlayVisible ? 'icons/icon-accordion-arrow-up.svg' : 'icons/icon-accordion-arrow-down.svg'"
                      [name]="nonLeakSelect.overlayVisible ? 'icon-accordion-arrow-up' : 'icon-accordion-arrow-down'"></svg-icon>
          </ng-template>
        </p-select>

      </div>

      @if (controls.nonLeakNoiseSource.value === NoiseSource.Other) {
        <div class="flex flex-col gap-[0.375rem] sm:order-last sm:col-span-2">
          <label class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)"
                 for="dialog-event-non-leak-other"
                 translate="@@fp-event-field__non-leak-other"></label>

          <input id="dialog-event-non-leak-other"
                 pInputText
                 type="text"
                 autocomplete="off"
                 formControlName="nonLeakOtherDetails"
                 class="w-full !h-[2.75rem] !text-[0.75rem] !font-medium placeholder:!text-(--p-gray-300)"
                 [placeholder]="'@@fp-event-field__non-leak-other-placeholder' | translate"/>
        </div>
      }
    }

    <div class="flex flex-col gap-[0.375rem]">
      <label class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)"
             for="dialog-event-pressure">
        <span translate="@@fp-event-field__pressure"></span>
      </label>

      <div class="flex items-stretch gap-[0.5rem]">
        <input id="dialog-event-pressure"
               pInputText
               type="number"
               min="0"
               step="0.1"
               inputmode="decimal"
               autocomplete="off"
               placeholder="0.0"
               formControlName="pressure"
               class="flex-1 min-w-0 !h-[2.75rem] !text-[0.875rem] !font-medium placeholder:!text-(--p-gray-300)"
               [class]="hasError(controls.pressure) ? '!border-(--p-other-red-500)' : ''"/>

        <p-select #pressureUnitSelect
                  panelStyleClass="p-special"
                  formControlName="pressureUnit"
                  [styleClass]="unitSelectClass"
                  [overlayOptions]="overlayOptions"
                  [options]="pressureUnits"
                  optionLabel="label"
                  optionValue="value">
          <ng-template #dropdownicon>
            <svg-icon class="text-inherit"
                      [src]="pressureUnitSelect.overlayVisible ? 'icons/icon-accordion-arrow-up.svg' : 'icons/icon-accordion-arrow-down.svg'"
                      [name]="pressureUnitSelect.overlayVisible ? 'icon-accordion-arrow-up' : 'icon-accordion-arrow-down'"></svg-icon>
          </ng-template>
        </p-select>
      </div>

      @if (hasError(controls.pressure)) {
        <span class="text-[0.75rem] font-medium text-(--p-other-red-500)"
              translate="@@fp-event-validation__pressure"></span>
      }
    </div>

    <div class="flex flex-col gap-[0.375rem]">
      <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)">
        <span translate="@@fp-event-field__soil-composition"></span>
      </span>

      <p-select #soilSelect
                panelStyleClass="p-special"
                formControlName="soilComposition"
                styleClass="w-full p-special !h-[2.75rem]"
                [overlayOptions]="overlayOptions"
                [options]="soilOptions"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'@@fp-event-field__soil-composition-placeholder' | translate">
        <ng-template #dropdownicon>
          <svg-icon class="text-inherit"
                    [src]="soilSelect.overlayVisible ? 'icons/icon-accordion-arrow-up.svg' : 'icons/icon-accordion-arrow-down.svg'"
                    [name]="soilSelect.overlayVisible ? 'icon-accordion-arrow-up' : 'icon-accordion-arrow-down'"></svg-icon>
        </ng-template>
      </p-select>

    </div>
  </div>

  @if (hasRepair()) {
    @let currentRepairStatus = controls.repairStatus.value;
    @let isScheduled = currentRepairStatus === RepairStatus.RepairScheduled;
    @let isRepaired = currentRepairStatus === RepairStatus.Repaired;

    <div class="h-[1px] w-full bg-(--p-primary-50)"></div>

    <div class="flex flex-col gap-[1rem]">
      <div class="flex flex-col gap-[0.5rem]">
        <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)"
              translate="@@shared-events-repair-status__text"></span>

        <div class="flex flex-wrap gap-[0.5rem]">
          @for (status of repairStatuses; track status) {
            @let isActive = currentRepairStatus === status;

            <p-button severity="secondary"
                      class="flex"
                      [styleClass]="'!gap-[0.375rem] !rounded-[0.5rem] !border !px-[1rem] !py-[0.4375rem] !text-[0.6875rem] !font-medium ' +
                        (isActive
                          ? repairStatusTheme[status] + ' !cursor-default !text-(--p-gray-950) ' + repairStatusBorder[status]
                          : '!border-(--p-blue-50) !text-(--p-gray-500) hover:!bg-(--p-neutral-500)')"
                      (onClick)="setRepairStatus(status)">
              <img class="size-[1.125rem] shrink-0"
                   [src]="repairStatusIcons[status]"
                   [alt]="repairStatusLabels[status] | translate"/>

              <span class="truncate" [translate]="repairStatusLabels[status]"></span>
            </p-button>
          }
        </div>
      </div>

      @if (isScheduled || isRepaired) {
        <div class="flex flex-col gap-[0.375rem]">
          <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-other-blue-120)">
            <span [translate]="isScheduled ? '@@fp-event-field__scheduled-date' : '@@fp-event-field__repair-date'"></span><span class="ml-[0.25rem] text-(--p-sky-500)">*</span>
          </span>

          <div class="w-full max-w-[25rem]">
            <p-datepicker formControlName="repairDate"
                          [styleClass]="'w-full' + (hasError(controls.repairDate) ? ' !border-(--p-other-red-500)' : '')"
                          inputStyleClass="!text-[0.75rem] !font-semibold !px-[0.75rem] !py-[0.75rem]"
                          appendTo="body"
                          [autoZIndex]="false"
                          panelStyleClass="!z-app-overlay-0"
                          showIcon="true"
                          iconDisplay="input"
                          [dateFormat]="dateFormat"
                          [keepInvalid]="true"
                          [minDate]="isScheduled ? today : undefined"
                          [maxDate]="isRepaired ? today : undefined"></p-datepicker>
          </div>

          @if (hasError(controls.repairDate)) {
            <span class="text-[0.75rem] font-medium text-(--p-other-red-500)"
                  [translate]="repairDateError()"></span>
          }
        </div>
      }
    </div>
  }
</div>
